import React from 'react';
import { ButtonProps, IconButtonProps, Tooltip } from '@material-ui/core';

import { Objects } from '@pitaman71/omniglot-live-data';

import { Plugin as Control, Modes } from './OfControls';
import { Plugin as Field } from './OfFields';
import * as Navigation from '../Navigation';
import { Factory } from '.';
import { Styler } from '..';

export interface Progress {
  expected?: number,
  completed?: number,
  errors?: number
};

export interface Plugin {
    key: (separator: string) => string,
    route: () => string,
    provide?: (children: JSX.Element[]|JSX.Element) => JSX.Element,
    progress?: () => Progress,
    context?: React.Context<any>,
    controls(filter: (control: Control) => boolean, render: (control: Control, options?: { ref?: React.RefObject<HTMLButtonElement> }) => JSX.Element): JSX.Element,
    icon: (props: { mode: Modes }) => undefined|JSX.Element,
    image: (pixelDimensions: { width: number, height: number }, imageProps: React.CSSProperties) => undefined|JSX.Element,
    label: (truncate?: { maxChars?: number }) => undefined|JSX.Element,
    summary: (options: { onClick: (editMode: boolean) => void, zeroPlaceholder?: () => JSX.Element }) => JSX.Element,
    fields: () => Field[],
    edit?: () => Plugin
}

export class Base<BindingType extends Objects.BindingType<string>, AuthorityTags> {
  _binding: BindingType;
  _factory: Factory<BindingType, AuthorityTags>;
  constructor(binding: BindingType, factory: Factory<BindingType, AuthorityTags>) { 
    this._binding = binding;
    this._factory = factory; 
  }
  key(separator: string): string { return this._factory.asPath().key(separator) }
  route(): string { return this._factory.asPath().to(this._binding)}
}

export function AsButton(props: ButtonProps & {
    view: Plugin,
    show?: {
      icon?: boolean|JSX.Element,
      label?: boolean|JSX.Element
    }
    refObject?: React.RefObject<HTMLButtonElement>
}) {
    const navigation = React.useContext(Navigation.Context);
    return (
      <Styler.Button 
        { ... props }
        id={props.view.key('-')}
        ref={props.refObject}
        startIcon={props.show?.icon === false ? undefined : (props.show?.icon === true || props.show?.icon === undefined) ? <AsIcon {...props}/> : props.show.icon } 
        onClick={() => { navigation.forward(props.view.route()); return Promise.resolve(); } }
      >{props.show?.label === false ? <React.Fragment/> : props.show?.label === true || props.show?.label === undefined ? props.view.label() : props.show.label }</Styler.Button>
    )
}

export function AsIconButton(props: IconButtonProps & {
  view: Plugin,
  refObject?: React.RefObject<HTMLButtonElement>
}) {
  const navigation = React.useContext(Navigation.Context);
  return <Styler.IconButton 
      { ... props }
      id={props.view.key('-')}
      ref={props.refObject}
      onClick={() => { navigation.forward(props.view.route()); return Promise.resolve(); } }
    ><AsIcon {...props}/></Styler.IconButton>;
}

export function AsIcon(props: {
  view: Plugin,
  busy?: boolean,
  disabled?: boolean,
  style?: React.CSSProperties
}) {
  const navigation = React.useContext(Navigation.Context);
  const _route = props.view.route();
  const mode = navigation.location.pathname === _route ? Modes.Selected : props.busy? Modes.Busy : props.disabled ? Modes.Disabled : Modes.Enabled;
  return props.view.icon({ mode }) || <React.Fragment></React.Fragment>;
}
